var link_preview_default = {
  "fontElementMap": "_1z7XZ",
  "linkPreviewContainer": "uuzPu",
  "linkPreview": "Un5y3",
  "linkPreviewImage": "QKD1a",
  "linkPreviewPlaceholder": "uhPlw",
  "linkPreviewInfo": "O4sKx",
  "linkPreviewTitle": "yK61p",
  "linkPreviewDescription": "Q2ocW",
  "linkPreviewUrl": "DEPKc",
  "linkPreviewResponsiveImage": "DCl-n",
  "loadingContainer": "ETRKZ",
  "errorIcon": "_45n95",
  "errorInfo": "vgFVI",
  "errorContainer": "ssc6f",
  "overlay": "UdFjs",
  "thumbnailEnd": "KIMg2",
  "thumbnailStart": "xzy3h",
  "thumbnailTop": "f5yXo"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
